/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accessdeniedpleaseloginagain5Inputs */

const en_accessdeniedpleaseloginagain5 = /** @type {(inputs: Accessdeniedpleaseloginagain5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access denied. Please log in again.`)
};

const de_accessdeniedpleaseloginagain5 = /** @type {(inputs: Accessdeniedpleaseloginagain5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Zugriff. Bitte melde dich nochmal an.`)
};

/**
* | output |
* | --- |
* | "Access denied. Please log in again." |
*
* @param {Accessdeniedpleaseloginagain5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const accessdeniedpleaseloginagain5 = /** @type {((inputs?: Accessdeniedpleaseloginagain5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accessdeniedpleaseloginagain5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_accessdeniedpleaseloginagain5(inputs)
	return de_accessdeniedpleaseloginagain5(inputs)
});
export { accessdeniedpleaseloginagain5 as "accessDeniedPleaseLogInAgain" }